import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ControlsModule } from 'app/controls/controls.module';
import { GalleryModule } from 'app/gallery/gallery.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { GalleryToolboxComponent
       } from './gallery-toolbox/gallery-toolbox.component';
import { ImageEditToolboxComponent
       } from './image-edit-toolbox/image-edit-toolbox.component';
import { ImageToolboxComponent } from './image-toolbox/image-toolbox.component';
import { LayoutToolboxComponent
       } from './layout-toolbox/layout-toolbox.component';
import { ProductChooserToolboxComponent
       } from './product-chooser-toolbox/product-chooser-toolbox.component';
import { TextEditToolboxComponent
       } from './text-edit-toolbox/text-edit-toolbox.component';
import { TextToolboxComponent } from './text-toolbox/text-toolbox.component';
import { ToolboxComponent } from './toolbox.component';

@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    DragDropModule,
    MatModule,
    GalleryModule,
    FormsModule,
    ImageSelectionDirectiveModule,
    TranslationModule,
  ],
  declarations: [
    GalleryToolboxComponent,
    ImageToolboxComponent,
    LayoutToolboxComponent,
    ProductChooserToolboxComponent,
    TextToolboxComponent,
    TextEditToolboxComponent,
    ImageEditToolboxComponent,
    ToolboxComponent,
  ],
  exports: [
    GalleryToolboxComponent,
    ImageToolboxComponent,
    LayoutToolboxComponent,
    ProductChooserToolboxComponent,
    TextToolboxComponent,
    TextEditToolboxComponent,
    ImageEditToolboxComponent,
  ],
})
export class ToolboxesModule { }
